import React from 'react';
import { Typography, Box } from '@mui/material';

const SectionTitle = ({ title, subtitle, align = 'center', light = false }) => {
  return (
    <Box sx={{ mb: 5, textAlign: align }}>
      <Typography
        variant="h3"
        component="h2"
        sx={{
          fontWeight: 700,
          color: light ? '#fff' : 'text.primary',
          mb: 1,
          fontSize: { xs: '1.8rem', md: '2.4rem' },
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="h6"
          sx={{
            color: light ? 'rgba(255,255,255,0.8)' : 'text.secondary',
            fontWeight: 400,
            maxWidth: 600,
            mx: align === 'center' ? 'auto' : 0,
          }}
        >
          {subtitle}
        </Typography>
      )}
      <Box
        sx={{
          width: 60,
          height: 4,
          borderRadius: 2,
          bgcolor: 'primary.main',
          mt: 2,
          mx: align === 'center' ? 'auto' : 0,
        }}
      />
    </Box>
  );
};

export default SectionTitle;
